export enum PreviewSessionStatus {
  ACTIVE = 'ACTIVE',
  TERMINATING = 'TERMINATING',
}

export interface PreviewSessionEntry {
  deviceId: string;
  customerId: string;
  creativeId: string;
  /** Expiration timestamp in milliseconds (Date.now() compatible) */
  expiresAt: number;
  status: PreviewSessionStatus;
}
